import React from 'react';
import { Link } from 'react-router-dom';
import MarketingReveal from './MarketingReveal';
import { DESTINATIONS } from './homeDummyContent';

/**
 * Peerspace destination grid — “New places, new possibilities”.
 */
const MarketingDestinationsBand = () => {
  return (
    <section className="border-t border-m-border-light bg-m-canvas-light px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <div className="mb-12 max-w-2xl sm:mb-16">
          <h2 className="marketing-section-title mb-3 text-m-ink">
            New places, new possibilities
          </h2>
          <p className="marketing-body-lg text-m-ink-muted">
            Browse dummy destinations across Canada — swap these for live markets
            whenever you’re ready.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {DESTINATIONS.map((dest) => (
            <Link
              key={dest.id}
              to={dest.href}
              className="group relative overflow-hidden rounded-2xl"
            >
              <img
                src={dest.image}
                alt=""
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5">
                <p className="text-lg font-medium tracking-tight text-white">{dest.city}</p>
                <p className="text-sm text-white/85">{dest.label}</p>
                <p className="mt-1 text-xs text-white/65">{dest.region}</p>
              </div>
            </Link>
          ))}
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingDestinationsBand;
